import { ProfileRegisterContainer } from './components/ProfileRegisterContainer';

export const ProfileRegisterPage = ProfileRegisterContainer;
